import { useState } from "react";
import { supabase } from "@/libs/supabase";

export const useDeleteChannel = () => {
	const [loading, setLoading] = useState(false);

	const deleteChannel = async (channelId: string) => {
		setLoading(true);
		try {
			const { error } = await supabase
				.from("channels")
				.delete()
				.eq("id", channelId);

			if (error) throw error;
		} finally {
			setLoading(false);
		}
	};

	return { deleteChannel, loading };
};
